module.exports = __webpack_public_path__ + "img/uhr.4196ea9f.svg";